// State represents the set of possible
// states the machine can be in.
export const States = [
  'Closed',
  'Open',
  'SearchRequested',
  'Searching',
  'SearchingSearchRequested',
] as const;
export type State = (typeof States)[number];

// Event represents all of the ways in
// with the state machine can change.
export const Events = [
  'Focus',
  'ClearSearchTerm',
  'SetSearchTerm',
  'SelectOption',
  'StartSearch',
  'CompleteSearch',
] as const;
export type Event = (typeof Events)[number];

// Note, States and Events are listed as const arrays
// because the test suite does a cross product and
// exhaustively checks every possible combination of
// State and Event.

// Action represents a set of external actions
// the state machine can request be made
export type Action =
  | 'SearchDebounced'
  | 'SearchImmediate'
  | 'FastSearchDebounced';

// Update takes and current state and an event and produces the next state
// and, optionally, and action to perform.
// If the a state/event combination is invalid, the original state is returned.
export function Update(s: State, e: Event): { state: State; action?: Action } {
  switch (s) {
    case 'Closed':
      switch (e) {
        case 'Focus':
          return { state: 'Open' };
        case 'SetSearchTerm':
          return { state: 'SearchRequested', action: 'SearchDebounced' };
      }
      break;
    case 'Open':
      switch (e) {
        case 'SetSearchTerm':
          return { state: 'SearchRequested', action: 'SearchDebounced' };
        case 'SelectOption':
          return { state: 'Closed' };
      }
      break;
    case 'SearchRequested':
      switch (e) {
        case 'ClearSearchTerm':
          return { state: 'Open' };
        case 'SetSearchTerm':
          return { state: 'SearchRequested', action: 'SearchDebounced' };
        case 'SelectOption':
          return { state: 'Closed' };
        case 'StartSearch':
          return { state: 'Searching' };
      }
      break;
    case 'Searching':
      switch (e) {
        case 'ClearSearchTerm':
          return { state: 'Open' };
        case 'SetSearchTerm':
          return {
            state: 'SearchingSearchRequested',
            action: 'FastSearchDebounced',
          };
        case 'SelectOption':
          return { state: 'Closed' };
        case 'CompleteSearch':
          return { state: 'Open' };
      }
      break;
    case 'SearchingSearchRequested':
      switch (e) {
        case 'SetSearchTerm':
          return {
            state: 'SearchingSearchRequested',
            action: 'FastSearchDebounced',
          };
        case 'ClearSearchTerm':
          return { state: 'Open' };
        case 'SelectOption':
          return { state: 'Closed' };
        case 'CompleteSearch':
          return { state: 'SearchRequested', action: 'SearchImmediate' };
      }
      break;
  }
  return { state: s };
}
